import state from "./moduleAlarmState.js";
import mutations from "./moduleAlarmMutations.js";
import actions from "./moduleAlarmActions.js";
import getters from "./moduleAlarmGetters.js";

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
